export const pauseAllMedia = () => {
	document.querySelectorAll(".js-youtube").forEach(pauseYouTubeVideo);
	document.querySelectorAll(".js-vimeo").forEach(pauseVimeoVideo);
	document.querySelectorAll("video").forEach(pauseVideo);
};

export const pauseYouTubeVideo = (video) => {
	video.contentWindow.postMessage(
		'{"event":"command","func":"pauseVideo","args":""}',
		"*"
	);
};
export const pauseVimeoVideo = (video) => {
	video.contentWindow.postMessage('{"method":"pause"}', "*");
};
export const pauseVideo = (video) => {
	video.pause();
};

export const playYouTubeVideo = (video) => {
	video.contentWindow.postMessage(
		'{"event":"command","func":"playVideo","args":""}',
		"*"
	);
};
export const playVimeoVideo = (video) => {
	video.contentWindow.postMessage('{"method":"play"}', "*");
};
export const playVideo = (video) => {
	video.play();
};
